module.exports = __webpack_public_path__ + "img/3-4.7f6ca027.png";